import { render } from "./App.vue?vue&type=template&id=590c7da7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=590c7da7&lang=css"

import exportComponent from "/Users/sweaton/WebstormProjects/paygateway/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__